import { render, staticRenderFns } from "./site-img.vue?vue&type=template&id=61db60c4&"
import script from "./site-img.vue?vue&type=script&lang=js&"
export * from "./site-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports